import { Separator } from "@/components/ui/separator";
export default function PrivacyPolicyOverview() {
  return <section data-section-id="154108" id="privacy-policy-overview" className="relative bg-background text-foreground overflow-hidden pt-24 pb-16 lg:pt-32 lg:pb-24">
      {/* Texture Layer */}
      <div className="absolute inset-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/naval_chart_texture.png)] bg-cover bg-center pointer-events-none mix-blend-overlay" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 bg-card/10 backdrop-blur-2xl border border-white/10 rounded-3xl shadow-xl">
        {/* Section Number */}
        <span className="block font-mono text-primary text-xl md:text-2xl mb-8 md:mb-12 text-center">
          01
        </span>

        {/* Heading */}
        <h1 className="font-default font-bold text-5xl md:text-6xl lg:text-[72px] leading-tight tracking-tight mb-12 lg:mb-20 text-center text-foreground">
          Privacy Policy
        </h1>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-start-7 lg:col-span-6">
            <p className="font-default font-light text-lg text-muted-foreground leading-relaxed">
              At YieldCapital, we believe that data prestige is as vital as financial performance. Our commitment to security ensures that your personal information is handled with the utmost discretion and protected by institutional-grade protocols.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Separator */}
      <Separator className="absolute bottom-0 left-0 w-full bg-border" />
    </section>;
}